export function formatIngredient(ing) {
  if (!ing) return '';
  if (typeof ing === 'string') return ing;
  const nombre = ing.nombre || '';
  const cantidad = (ing.cantidad !== undefined && ing.cantidad !== null) ? String(ing.cantidad).trim() : '';
  const unidad = ing.unidad ? String(ing.unidad).trim() : '';
  const cantidadParte = (cantidad && cantidad !== '0') ? cantidad : '';
  const unidadParte = unidad ? unidad : '';
  if (cantidadParte || unidadParte) {
    return `${[cantidadParte, unidadParte].filter(Boolean).join(' ')} de ${nombre}`.trim();
  }
  return nombre;
}